export default __webpack_public_path__ + "static/media/unfinished3.dca5900e.png";